const eventConfig = {
    playEffect:"playEffect",
    despositReponse:"despositResponse",
    facebookResponse:"facebookResponse",
    autoSetVerifyCode: "autoSetVerifyCode",
    autoSetCode: "autoSetCode",
    LOADING:"isInLoading",
    LOGIN_SUC:"loginSuccess",
    LOGIN_PAGE:"loginPage",
    LOGIN_ERROR:"loginError",
    CODE_ERROR:"codeError",
    REFRESH_MONEY:"refresh_point",
    PAY_SUCCESS:"payment_successfull",
    PAY_CANCEL:"user_cancelled",
    CONTINUE_GAME:"continue_togame",
    NO_LOGIN_FLAG:-100000000,
    CONTINUE_GAME_ID:6022,
    google:{
        home:{
            EVENT:"homeEvent",
            LOGIN:"login_btn",
            CONTINUE:"continue_game",
            BET_RECORD:"bet_record",
            actionRoomStart:function(isDemo) { 
                return ("actionRoom_1" + (isDemo ? "demo" : "cash"));
            },
            actionRoomSel:function(isDemo) { 
                return ("actionRoom_2" + (isDemo ? "demo" : "cash"));
            },
            actionRoomEnd:function(isDemo) { 
                return ("actionRoom_3" + (isDemo ? "demo" : "cash"));
            },
        },
        login:{
            EVENT:"loginEvent",
            MAIL_PRESS:"mail_code_press",
            MAIL_SEND:"mail_code_send",
            MAIL_SUCCESS:"mail_succcess",
            LOGIN_SUCCESS:"login_succcess",
            MAIL_CHECKER:"mail_chcker",
            FACEBOOK_PRESS:"facebook_press",
            FACEBOOK_RETURN:"facebook_return",
            FACEBOOK_SUCCESS:"facebook_succcess",
            MAIL_EVENT:"mail_time",
            COMMON_LOGIN:"common_login",
            FACEBOOK_LOGIN:"facebook_login"
        },
        pay:{
            EVENT:"payEvent",
            DEPOSIT_PAGE:"deposit_page",
            DEPOSIT_RECORD:"deposit_record",
            DEPOSIT:"deposit",
            DEPOSIT_SUCCESS:"deposit_success",
            WITHDRAW_PAGE:"withdraw_page",
            WITHDRAW_RECORD:"withdraw_record",
            WITHDRAW:"withdraw",
            WITHDRAW_SUCCESS:"withdraw_success",            
        },
        init:{
            EVENT:"init",
            END_IFRAME:"endIframe",
            END_RENDER:"endRender"
        }
    }
};

export default eventConfig;


// WEBPACK FOOTER //
// ./src/baseConfig/eventConfig/index.js